import { render, staticRenderFns } from "./RoadmapVirtualEskom.vue?vue&type=template&id=85079908&scoped=true&"
import script from "./RoadmapVirtualEskom.vue?vue&type=script&lang=js&"
export * from "./RoadmapVirtualEskom.vue?vue&type=script&lang=js&"
import style0 from "./RoadmapVirtualEskom.vue?vue&type=style&index=0&id=85079908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85079908",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCol,VContainer,VIcon,VImg,VRow})
